import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Box, Coins, Loader2, X } from "lucide-react";

/** Modal del diseño 3D anamórfico (IA de imagen). */
export const Design3dModal = ({
  open, onClose, busy, object, onObjectChange, mode, onModeChange,
  quality, onQualityChange, onRun,
}) => {
  if (!open) return null;
  const close = () => { if (!busy) onClose(); };
  return (
        <div data-testid="modal-3d" className="fixed inset-0 z-50 flex items-center justify-center p-6"
          style={{ backgroundColor: "rgba(0,0,0,0.75)" }} onClick={() => close()}>
          <div className="rounded-xl border max-w-lg w-full" style={{ borderColor: "#1E293B", backgroundColor: "#0D111A" }}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: "#1E293B" }}>
              <div className="font-heading font-bold text-sm text-slate-100 flex items-center gap-2">
                <Box className="w-4 h-4 text-amber-400" /> Diseño 3D que sale del papel
              </div>
              <button data-testid="modal-3d-close" onClick={() => close()}
                className="text-slate-400 hover:text-slate-200"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-5">
              <p className="text-xs text-slate-400 leading-relaxed mb-3">
                La IA crea una ilusión óptica anamórfica: el objeto parece salir de la hoja,
                con volumen y sombra real sobre el papel.
              </p>
              <label className="text-[11px] text-slate-500">¿Qué quieres que salga del papel?</label>
              <Input data-testid="input-3d-object" value={object} autoFocus
                onChange={(e) => onObjectChange(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && !busy) onRun(); }}
                placeholder="Ej.: una luna gris con cráteres, un dragón, un edificio…"
                className="bg-[#0B0F19] border-[#334155] text-slate-100 text-sm mt-1" />

              <div className="grid grid-cols-2 gap-2 mt-4">
                {[["document", "Sobre mi documento", "Conserva tu hoja y le agrega el objeto en 3D"],
                  ["new", "Crear hoja nueva", "Genera una foto nueva con la hoja y el objeto 3D"]].map(([v, t, d]) => (
                  <button key={v} data-testid={`mode-3d-${v}`} onClick={() => onModeChange(v)}
                    className={`text-left p-3 rounded-lg border transition-colors ${mode === v ? "border-amber-500 bg-amber-500/10" : "border-[#1E293B] hover:bg-[#111827]"}`}>
                    <div className="text-sm text-slate-100 font-bold">{t}</div>
                    <div className="text-[11px] text-slate-500 mt-0.5">{d}</div>
                  </button>
                ))}
              </div>
              <div className="text-[11px] text-slate-600 mt-3 flex items-center gap-1">
                <Coins className="w-3 h-3 text-amber-400" /> Calidad y costo:
              </div>
              <div className="flex items-center gap-1.5 mt-1">
                {[["1k", "1K · 6 créditos"], ["2k", "2K · 10 créditos"], ["4k", "4K · 15 créditos"]].map(([v, l]) => (
                  <button key={v} data-testid={`quality-3d-${v}`} onClick={() => onQualityChange(v)}
                    className={`flex-1 py-1.5 rounded-md border text-[11px] ${quality === v ? "border-amber-500 bg-amber-500/10 text-amber-300" : "border-[#1E293B] text-slate-300 hover:bg-[#111827]"}`}>
                    {l}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 px-5 py-3 border-t" style={{ borderColor: "#1E293B" }}>
              <Button data-testid="modal-3d-cancel" onClick={() => close()} disabled={!!busy}
                variant="outline" className="border-[#334155] bg-transparent text-slate-200 hover:bg-[#1E293B]">Cancelar</Button>
              <Button data-testid="run-3d-btn" onClick={onRun} disabled={!!busy || !object.trim()}
                className="text-white" style={{ background: "linear-gradient(135deg,#F59E0B,#8B5CF6)" }}>
                {busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Box className="w-4 h-4 mr-1" />}
                Crear en 3D
              </Button>
            </div>
          </div>
        </div>
      );
};

export default Design3dModal;
